export const environment = {
    sandbox: {
        clientId: process.env.REACT_APP_CLIENT_ID_SANDBOX,
        clientSecret: process.env.REACT_APP_CLIENT_SECRET_SANDBOX,
        merchantId: process.env.REACT_APP_MERCHANT_ID_SANDBOX
    },
    production: {
        clientId: process.env.REACT_APP_CLIENT_ID_PROD,
        clientSecret: process.env.REACT_APP_CLIENT_SECRET_PROD,
        merchantId: process.env.REACT_APP_MERCHANT_ID_PROD
    }
};
